import { has } from 'lodash/fp';
import { IN_PERSON_TRAINING } from 'constants/actionTypes';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import serializeUrl from 'utils/serialize_url';
import createActionsCreators from 'utils/createActionsCreators';

const actions = createActionsCreators({
  dataRequest: IN_PERSON_TRAINING.ATTENDANCES.DATA_REQUEST,
  dataReceive: IN_PERSON_TRAINING.ATTENDANCES.DATA_RECEIVE,
  setFilters: IN_PERSON_TRAINING.ATTENDANCES.SET_FILTERS,
});

export function requestAttendees(sessionId) {
  return (dispatch, getState) =>
    new Promise(resolve => {
      dispatch(actions.dataRequest());
      const { event, attendees } = getState();
      const route = sessionId
        ? routes.IN_PERSON_TRAINING.SESSION_GUESTS(event.id, sessionId)
        : routes.IN_PERSON_TRAINING.EVENT_GUESTS(event.id);
      request.get(serializeUrl(route, attendees.filters)).then(data => {
        dispatch(actions.dataReceive(data));
        resolve();
      });
    });
}

export function updateFilters(changesToApply, sessionId) {
  return (dispatch, getState) => {
    const changes = { ...changesToApply };
    if (has('query', changes)) {
      const query = changes.query.trim();
      const prevQuery = getState().attendees.filters.query.trim();
      if (query !== prevQuery.trim()) {
        changes.rsvpStatus = null; // will always reset status when entering or exiting searching
        changes.attendanceStatus = null; // will always reset status when entering or exiting searching
      }
    }
    dispatch(actions.setFilters(changes));
    dispatch(requestAttendees(sessionId));
  };
}

export function updateAttendees(sessionId) {
  return (dispatch, getState) => {
    const { attendees } = getState();
    const { attendances } = attendees;
    if (attendances.data.length === 1) {
      dispatch(
        updateFilters({ attendanceStatus: '', rsvpStatus: '' }, sessionId),
      );
    } else {
      dispatch(requestAttendees(sessionId));
    }
  };
}
